import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3faeb3be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消确认")
const _hoisted_4 = {
  key: 0,
  class: "checkTable mt-10"
}
const _hoisted_5 = {
  class: "tftable",
  border: "1"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "th--column--1" }, "日期", -1))
const _hoisted_7 = { class: "td--column--1" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import { ref, Ref, reactive, computed, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import dayjs from 'dayjs'
import { useStore} from 'vuex'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  props: {
    searchObj: null,
    tableFunc: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  searchObj: { userId: string | number, date: string}
  tableFunc: any
}

let {
  'POST/project_cost_time/click': fetchList,
  // 获取项目
  'GET/projects': fetchProjectApi,
  // 获取-项目成本人员勾选信息
  'POST/project_cost_time/user': fetchCostApi,
  // 产生个人项目成本
  'POST/project_cost_time/generate': generateApi,
} = Api

const store = useStore()


let date = ref(dayjs().subtract(1, 'month').format('YYYY-MM-DD'))
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const { 
  MI_tableData: costData, fetchData: fetchCost, page: costPage, size: costSize, MI_total: costTotal,
  MI_pageChange: costPgCg, MI_sizeChange: costSzCg, MI_identify: costIdentify, MI_params: costParams
} = new tbMix(props.tableFunc)

// 获取当月完整日期Array
const fullMonthDays = computed(() => {
  let daysArr = []
  let startDay =  dayjs(costParams.date).startOf('month').format('YYYY-MM-DD')
  let days = dayjs(costParams.date).daysInMonth()

  for (let index = 0; index < days; index++) {
    daysArr.push(dayjs(startDay).startOf('month').add(index, 'day').format('YYYY-MM-DD'))
  }
  return daysArr
})


// 详情
let userRow: any = reactive({})
const searchHandle = (parmas: any) => {
  fetchCost({
    ...parmas,
    userId: store.state.userId,
  })
}

// 月份改变搜索
const changeHandle = (val: string) => {
  searchHandle({date: val})
}


const _costData = computed(() => {
  return costData.value.map(project => {
    // 全选绑定
    project.checkAll = false
    // 创建日期绑定
    project.customInfo = project.dateInfo.reduce((obj: any, _date: any) => {
      obj[_date.date] = {..._date, dis: _date.locked}
      return obj
    }, {})

    return project
  })
})

// 全选
const checkAllHandle = (project: any) => {
  if (project.checkAll === true){
    // 全选
    for (const date in project.customInfo) {
      if(project.customInfo[date].dis !== true){
        project.customInfo[date].locked = true
      }
    }
    return
  } 
  // 取消全选
  for (const date in project.customInfo) {
    if(project.customInfo[date].dis !== true){
      project.customInfo[date].locked = false
    }
  }
  
}

// 取消确认
const cancelConfirm = ref<boolean>(true)
// 确认
const submitHandle = () => {
  let costList = _costData.value.reduce((arr, project) => {
    if(project.click === false) return arr;
    arr.push({
      userId: project.userId,
      projectId: project.projectId,
      projectName: project.projectName,
      click: project.click,
      dateInfo: Object.values(project.customInfo)
    })
    return arr
  }, [])
  costIdentify.value = true
  generateApi({
    userId: props.searchObj.userId as number,
    date: props.searchObj.date,
    costList,
  }).then(() => {
    cancelConfirm.value = true
    ElMessage.success('保存成功')
    costIdentify.value = false
    searchHandle(costParams)
    
  }).catch(() => {
    costIdentify.value = false
  })
}
// 取消确认
const cancelHandle = () => {
  _costData.value.map(project => {
    // if(project.checkAll === true) return;
    for (const date in project.customInfo) {
      project.customInfo[date].dis = false
    }
  })
}



expose({
  searchHandle
})

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_date_picker, {
        modelValue: _unref(date),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(date) ? (date).value = $event : date = $event)),
        clearable: false,
        type: "month",
        onChange: changeHandle,
        "value-format": "YYYY-MM-DD",
        placeholder: "请选择月份",
        class: "mr-10"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        icon: "refresh",
        type: "info",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeHandle(_unref(date))))
      }),
      (_unref(costData).length > 0)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (submitHandle()))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(costData).length > 0)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: cancelHandle
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_unref(costData).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_6,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_costData), (project) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: project.projectId,
                    class: "projectTit"
                  }, [
                    _createElementVNode("p", null, _toDisplayString(project.projectName), 1),
                    _createElementVNode("p", null, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: project.checkAll,
                        "onUpdate:modelValue": ($event: any) => ((project.checkAll) = $event),
                        disabled: !project.click,
                        onChange: ($event: any) => (checkAllHandle(project))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fullMonthDays), (day) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(day), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_costData), (_project) => {
                    return (_openBlock(), _createElementBlock("td", null, [
                      (_project.customInfo[day])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_component_el_checkbox, {
                              modelValue: _project.customInfo[day].locked,
                              "onUpdate:modelValue": ($event: any) => ((_project.customInfo[day].locked) = $event),
                              disabled: !_project.click || _project.customInfo[day].dis
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 256))
                ]))
              }), 256))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(_costData).length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 暂无参与项目 "))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _unref(costIdentify)]
  ])
}
}

})